module.exports = __webpack_public_path__ + "static/media/arsene_head.2a50f433.png";